const newFaqContentEvSF = [
  {
    title: 'What is Autzu EV?',
    info: [
      {
        pretext:
          'Autzu EV is our tier of zero-emission electric vehicles, starting at $7 per hour. Autzu EV vehicles allow you to accept various ridesharing trip requests, including: '
      },
      {
        text: {
          plaintext: 'Standard (UberX, UberX Share, Uber Pet)'
        }
      },
      {
        text: { plaintext: 'Premium (Uber Comfort, Premier)' }
      },
      {
        text: { plaintext: 'Green (Uber Green, Comfort Electric)' }
      },
      {
        text: { plaintext: 'Other (Pet, Connect)' }
      },
      {
        text: { plaintext: 'Food Delivery (Uber Eats)' }
      },

      {
        link: {
          leadingText:
            'When driving Autzu EV, you will be able to opt-in to Uber’s Zero Emission Incentive program. Starting on April 11, 2024, drivers of fully electric vehicles can earn an extra $210 after completing 200 eligible rides in an EV every 30 days through the end of 2024. Learn more about how you can reduce your carbon footprint by going green ',
          title: 'here',
          href:
            'https://www.uber.com/us/en/drive/services/electric/?uclick_id=346a868e-74fc-4620-b616-7e6f19f7a244',
          trailingText:
            '. Autzu EV drivers will also automatically get $0.50 extra directly from riders for each Uber Green trip.'
        }
      }
    ]
  },
  {
    title: 'What kind of vehicles are available on Autzu EV?',
    info: [
      {
        pretext:
          'At Autzu, we offer the sleek and high-performing Tesla Model 3 in both Long Range and Standard Range options. Our vehicles are automatically assigned for you, ensuring that you always have the best vehicle for your needs. While you may not be able to select a specific vehicle, rest assured that all of our vehicles are top-quality and well-maintained for your enjoyment.'
      }
    ]
  },
  {
    title: 'How much does it cost to recharge the vehicle?',
    info: [
      {
        pretext:
          'Charging from 0-100% at a Tesla Supercharger costs approximately $25-35, and takes 30-45 minutes. Vehicles are to be returned with at least 70% at the end of the booking.'
      }
    ]
  }
];

export default newFaqContentEvSF;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/NewEVFaqContentSF.js